export const philosophy = [
  [
    "Trace the Full Workflow",
    "Follow data from collection to processing, detection, reporting, and remediation so the full system behavior is understood.",
  ],
  [
    "Prove Real-World Impact",
    "A finding matters only when it changes risk, visibility, or response quality in practice.",
  ],
  [
    "Reduce Noise, Increase Trust",
    "Tune alerts, automate repetitive checks, and keep the signal clear so operators can act with confidence.",
  ],
  [
    "Think Like an Adversary",
    "Understand how findings, misconfigurations, and weak controls can chain into an attack path.",
  ],
];